var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('hero'),_c('about-us'),_c('why-us'),_c('faq'),_c('roadmap')],1)}
var staticRenderFns = []

export { render, staticRenderFns }